module.exports = __webpack_public_path__ + "static/img/15.f757565.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/sp/15.png
// module id = WqdW
// module chunks = 0